export const routePathMap = {
  notes: '/my-work',
  smartDiary: '/smart-timesheet',
  collectors: '/collectors',
  settings: '/settings',
  insights: '/insights'
};
